import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatDateDb, formatDateHourDb } from "../utils/tools";
import {
  customDateFormatType,
  formatDateForInput,
  formatNumber,
} from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.lockingManagement;
const queryKey = "locking";

async function fetchLocking(
  currentPage,
  search,
  projectId,
  bookerId,
  lockingEventId,
  status,
  isTtkqHdmbs,
  apartmentId,
  customerId,
  startTime,
  endTime,
  saleBlockId,
  saleAreaId,
  startTimeCreated,
  endTimeCreated,
  inputLate
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (projectId?.length) options.projectId = projectId;
    if (bookerId) options.bookerId = bookerId;
    if (lockingEventId) options.lockingEventId = lockingEventId;
    if (status?.length) options.status = status;
    if (isTtkqHdmbs) options.isTtkqHdmbs = isTtkqHdmbs;
    if (apartmentId?.length) options.apartmentId = apartmentId;
    if (customerId) options.customerId = customerId;
    if (startTime) options.startTime = customDateFormatType(startTime);
    if (endTime) options.endTime = customDateFormatType(endTime);
    if (saleBlockId) options.saleBlockId = saleBlockId;
    if (saleAreaId) options.saleAreaId = saleAreaId;
    if (startTimeCreated) options.startTimeCreated = customDateFormatType(startTimeCreated);
    if (endTimeCreated) options.endTimeCreated = customDateFormatType(endTimeCreated);
    if (inputLate) options.inputLate = inputLate;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/locking?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?._id || "",
        status: item?.status || "",
        statusTtkqSalesContract:
          item?.statusTtkq || item?.statusSalesContract ? true : false,
        inputLate: item?.inputLate || false,
        isWrongInput: item?.isWrongInput ? true : false,
        wrongLockingCount: item?.booker?.wrongLockingCount ?? 0,
        codeApartment: item?.apartmentObject?.code || "-",
        nameProject: item?.projectObject?.name || "-",
        nameCustomer: item?.customerObject?.name || "-",
        bookingTime: item?.bookingTime ? formatDateDb(item?.bookingTime) : "-",
        participants: item?.participants || [],
        nameLocking: item?.bookerObject?.fullName || "-",
        saleBlock: item?.saleBlock?.name || "-",
        saleArea: item?.saleArea?.name || "-",
        createdAt: item?.createdAt ? formatDateHourDb(item?.createdAt) : "-",
        // saleOpeningEvent: item?.saleOpeningEvent?.code || "-",
        // booking: item?.booking?.code || "-",
        // nameApartment: item?.apartmentObject?.name || "-",
        // price: item?.price
        //   ? `${formatNumber(Number(item?.price))} VNĐ`
        //   : "0 VNĐ",
        // agentName: item?.agent?.name || "-",
        // note: item?.note || "-",
        statusTtkq: item?.statusTtkq ? true : false,
        statusSalesContract: item?.statusSalesContract ? true : false,
        is_allow_ttkq: item?.project?.is_allow_ttkq || false,
        edit: {
          id: item?._id || "",
          note: item?.note || "",
          nameBooker: item?.nameBooker || "",
          projectId: item?.projectId || "",
          saleOpeningEventId: item?.saleOpeningEventId || "",
          bookingId: item?.bookingId || "",
          customerId: item?.customerId || "",
          price: item?.price || "",
          bookingTime: item?.bookingTime
            ? formatDateForInput(item?.bookingTime)
            : "",
          apartmentId: item?.apartmentId || "",
          paymentMethodId: item?.paymentMethodId || "",
          bookerId: item?.bookerId || "",
          createdAt: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
          images: item?.images,
          isWrongInput: item?.isWrongInput ? true : false,
        },
        detail: {
          id: item?._id || "",
          status: item?.status || "",
          saleOpeningEvent: item?.saleOpeningEvent?.code || "",
          saleOpeningEventId: item?.saleOpeningEventId || "",
          booking: item?.booking?.code || "",
          bookingId: item?.bookingId || "",
          bookerId: item?.bookerId || "",
          note: item?.note || "",
          nameBooker: item?.bookerObject?.fullName || "",
          createdAt: item?.createdAt || "",
          projectName: item?.project?.name || "",
          projectId: item?.projectId || "",
          customerName: item?.customerObject?.name || "",
          customerId: item?.customerId,
          price: item?.price || "",
          bookingTime: item?.bookingTime || "",
          apartment: item?.apartmentObject?.name || "",
          apartmentCode: item?.apartmentObject?.code || "",
          apartments: item?.apartment,
          apartmentId: item?.apartmentId,
          paymentMethod: item?.paymentMethod?.name || "",
          images: item?.images,
          agentName: item?.agent?.name || "-",
          saleBlock: item?.saleBlock?.name || "-",
          saleArea: item?.saleArea?.name || "-",
          customer: item?.customer,
        },
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useLocking(
  search,
  projectId,
  bookerId,
  lockingEventId,
  status,
  isTtkqHdmbs,
  apartmentId,
  customerId,
  startTime,
  endTime,
  saleBlockId,
  saleAreaId,
  startDateCreated,
  endDateCreated,
  inputLate
) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      queryKey,
      currentPage,
      search,
      projectId,
      bookerId,
      lockingEventId,
      status,
      isTtkqHdmbs,
      apartmentId,
      customerId,
      startTime,
      endTime,
      saleBlockId,
      saleAreaId,
      startDateCreated,
      endDateCreated,
      inputLate,
    ],
    queryFn: () =>
      fetchLocking(
        currentPage,
        search,
        projectId,
        bookerId,
        lockingEventId,
        status,
        isTtkqHdmbs,
        apartmentId,
        customerId,
        startTime,
        endTime,
        saleBlockId,
        saleAreaId,
        startDateCreated,
        endDateCreated,
        inputLate
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    lockingManagementData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
